<!-- 事件元数据显示 -->
<template>
    <div class="EventMetadataWrap">
      <div class="MetadataActiveBox" :class="PositionClass">
        <div class="eventMessageBox" :style="{background: event.backgroundColor}">
          <div class="eventMessageTop">
            <p class="eventMessageTitle">{{EventTitle(event)}}</p>
             <event-icon-wrap :event="event"></event-icon-wrap>
          </div>
          <div class="Metadata">
            <div class="Series" v-if="IsShowData('series')">{{event.series}}</div>
            <div class="EpisodeTitle" v-if="IsShowData('episodeTitle')">{{event.episodeTitle}}</div>
            <div class="SeasonEpisode">
              <div class="Season" v-if="IsShowData('season')">{{$t('lang.Season')}}: {{event.season}}</div>
              <div class="Episode" v-if="IsShowData('episode')">{{$t('lang.Episode1')}}: {{event.episode}}</div>
            </div>
          </div>
        </div>
        <i class="el-icon-caret-bottom" :style="{color: event.backgroundColor}"></i>
        <i class="el-icon-caret-top" :style="{color: event.backgroundColor}"></i>
      </div>
    </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import { mapState } from 'vuex'
import EventIconWrap from '@/components/common/EventMetadata/EventIconWrap.vue'
export default {
  props: {
    // 事件信息
    event: {
      type: Object,
      default: () => ({})
    },
    // 鼠标位置
    BoxPosition: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    EventIconWrap
  },
  computed: {
    ...mapState({
      // 高级配置的某些参数
      AdvancedSetupConfig: (state) => state.playout.AdvancedSetupConfig
    })
  },
  watch: {
    AdvancedSetupConfig: {
      handler (item) {
        this.displayEventMetadata = item.displayEventMetadata ? item.displayEventMetadata.split(',') : []
      },
      immediate: true
    }
  },
  data () {
    return {
      // 位置
      PositionClass: '',
      // 显示哪些
      displayEventMetadata: ''
    }
  },
  created () {
    this.initPosition()
  },
  mounted () {

  },
  methods: {
    // 初始化位置
    initPosition () {
      let PositionClass = ''
      if (this.BoxPosition.top < 300) {
        PositionClass = 'eventActiveBoxBottom'
      }
      if (this.BoxPosition.right < 250) {
        PositionClass = `${PositionClass} eventActiveBoxRight`
      }
      this.PositionClass = PositionClass
    },
    // 事件标题
    EventTitle (item) {
      const startTime = Outil.changeNewTime(item.startTime)
      const endTime = Outil.changeNewTime(item.endTime)
      return `${startTime}-${endTime} ${item.title}`
    },
    // 是否显示数据
    IsShowData (key) {
      let IsShow = false
      if (this.displayEventMetadata.includes(key)) {
        IsShow = true
      }
      return IsShow
    }
  }
}
</script>

<style scoped lang="less">
.EventMetadataWrap {
  .MetadataActiveBox {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 150%;
    z-index: 100000000000;
    padding-bottom: 11px;
    transform: translateY(-100%);
    .eventMessageBox {
      box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.5);
      border-radius: 3px;
      padding: 8px 10px;
      text-align: left;
      .eventMessageTop {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .eventMessageTitle {
          width: 70%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin: 0;
          color: #252525;
          font-size: 14px;
        }
      }
      .Metadata {
        color: #252525;
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0px;
        .SeasonEpisode {
          display: flex;
          .Season {
            margin-right: 10px;
          }
        }
      }
    }
    .el-icon-caret-bottom {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -6px;
      font-size: 30px;
    }
    .el-icon-caret-top {
      display: none;
    }
  }
  .eventActiveBoxRight {
    left: -50%;
    z-index: 100000000000;
  }
  .eventActiveBoxBottom {
    top: 100%;
    z-index: 100000000000;
    transform: translateY(0);
    .eventMessageBox {
      transform: translateY(11px);
    }
    .el-icon-caret-bottom {
      display: none;
    }
    .el-icon-caret-top {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -9px;
      font-size: 30px;
      display: inline;
    }
  }
}
</style>
